export const MenuIcon: React.FC<React.SVGAttributes<{}>> = props => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" width={22} height={20} {...props}>
        <path d="M1.375 2.46777H20.625" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M1.375 9.69531H20.625" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M1.375 16.9238H20.625" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);
